module.exports = __webpack_public_path__ + "img/2.0c93a1ea.png";